import type { CSSProperties, HTMLAttributes } from "react";
import { brandAssets } from "../assets/brand";
import { tokens } from "../theme";

/** `accent` = themed brand ramp; `onBrand` = flat white on accent surfaces */
export type AvatarIconVariant = "accent" | "onBrand";

export interface AvatarIconProps extends Omit<
  HTMLAttributes<HTMLSpanElement>,
  "children"
> {
  variant?: AvatarIconVariant;
  size?: number;
  alt?: string;
  style?: CSSProperties;
}

/**
 * Brand robot mark.
 *
 * Geometry stays in the SVG asset, colour comes from tokens: the shape is used
 * as a CSS mask so the mark follows `theme.accent_color` from GET /v1/config
 * instead of the palette baked into the file.
 */
export default function AvatarIcon({
  variant = "accent",
  size = 28,
  alt = "",
  style,
  ...rest
}: AvatarIconProps) {
  const paint =
    variant === "onBrand" ? tokens.text.onBrand : tokens.gradient.accent;
  const mask = `url("${brandAssets.iconWhite}") center / contain no-repeat`;

  return (
    <span
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{
        width: size,
        height: size,
        display: "block",
        flexShrink: 0,
        background: paint,
        WebkitMask: mask,
        mask,
        ...style,
      }}
      {...rest}
    />
  );
}
